import { Routes } from '@angular/router';
import { DashboardError404Page } from '@eforall/dashboard';
import { DashboardPage } from './pages/dashboard/dashboard.page';
import { HomePage } from './pages/home/home.page';


export const routes: Routes = [
	{
		path: '',
		children: [

			{ path: '', component: HomePage },
			{
				path: ':urlKey',
				children: [
					{ path: '', redirectTo: 'no-name', pathMatch: 'full' },
					{ path: ':nameSlug', component: DashboardPage }
				]
			},

		]
	},

	//
	// Page not found
	//
	{ path: '**', component: DashboardError404Page },

];
